function normalizeUri(uri: string): string {
    if (!uri.startsWith('ipfs://')) return uri;
    return 'https://cloudflare-ipfs.com/ipfs/' + uri.substring(7);
}

export { normalizeUri }